/**
 * Phase 15 Plan 15-02 — MonthLockedBadge
 *
 * Renders a destructive <Badge> with the text "Month Locked" when `locked === true`.
 * Returns null when `locked === false` (or `locked` is undefined).
 *
 * Props:
 *   locked — whether the month is locked
 *   month  — optional "YYYY-MM" label shown as tooltip title
 */

import type { JSX } from 'react';

import { Badge } from '@/components/ui/badge';

export interface MonthLockedBadgeProps {
  readonly locked: boolean;
  /** Optional month label shown as tooltip title when locked=true. */
  readonly month?: string;
}

export function MonthLockedBadge({ locked, month }: MonthLockedBadgeProps): JSX.Element | null {
  if (!locked) return null;

  return (
    <Badge
      variant="destructive"
      title={month !== undefined ? `Month ${month} is locked` : 'Month is locked'}
      data-testid="month-locked-badge"
    >
      Month Locked
    </Badge>
  );
}
